const types = {
  FETCH_OPERATOR_SUBORDINATES_START: 'FETCH_OPERATOR_SUBORDINATES_START',
  FETCH_OPERATOR_SUBORDINATES_SUCCESS: 'FETCH_OPERATOR_SUBORDINATES_SUCCESS',
  FETCH_OPERATOR_SUBORDINATES_FAILURE: 'FETCH_OPERATOR_SUBORDINATES_FAILURE',
  DELETE_OPERATOR_SUBORDINATE_START: 'DELETE_OPERATOR_SUBORDINATE_START',
  DELETE_OPERATOR_SUBORDINATE_SUCCESS: 'DELETE_OPERATOR_SUBORDINATE_SUCCESS',
  DELETE_OPERATOR_SUBORDINATE_FAILURE: 'DELETE_OPERATOR_SUBORDINATE_FAILURE',
  FETCH_ALL_ROLES_START: 'FETCH_ALL_ROLES_START',
  FETCH_ALL_ROLES_SUCCESS: 'FETCH_ALL_ROLES_SUCCESS',
  FETCH_ALL_ROLES_FAILURE: 'FETCH_ALL_ROLES_FAILURE',
  FETCH_ALL_VEHICLES_START: 'FETCH_ALL_VEHICLES_START',
  FETCH_ALL_VEHICLES_SUCCESS: 'FETCH_ALL_VEHICLES_SUCCESS',
  FETCH_ALL_VEHICLES_FAILURE: 'FETCH_ALL_VEHICLES_FAILURE',
  FETCH_PERMISSION_START: 'FETCH_PERMISSION_START',
  FETCH_PERMISSION_SUCCESS: 'FETCH_PERMISSION_SUCCESS',
  FETCH_PERMISSION_FAILURE: 'FETCH_PERMISSION_FAILURE',
  CREATE_ROLE_START: 'CREATE_ROLE_START',
  CREATE_ROLE_SUCCESS: 'CREATE_ROLE_SUCCESS',
  CREATE_ROLE_FAILURE: 'CREATE_ROLE_FAILURE',
  ADD_ROLE_START: 'ADD_ROLE_START',
  ADD_ROLE_SUCCESS: 'ADD_ROLE_SUCCESS',
  ADD_ROLE_FAILURE: 'ADD_ROLE_FAILURE',
  DELETE_ROLE_START: 'DELETE_ROLE_START',
  DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',
  DELETE_ROLE_FAILURE: 'DELETE_ROLE_FAILURE',
  ADD_USER_START: 'ADD_USER_START',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  ADD_USER_FAILURE: 'ADD_USER_FAILURE',
  REMOVE_USER_SUCCESS: 'REMOVE_USER_SUCCESS',
};
export default types;
